import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  ChipField,
} from 'react-admin';

export const TagShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <ChipField source="name" />
      <TextField source="slug" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
